<template>
<div class="content-body tenant-settings">
    <!-- <div class="" style="background: red ;display: none"> -->
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <!-- <el-form-item label="工厂:">
                <el-input size="small" v-model="dataForm.werks" placeholder="工厂" clearable @blur="getDataList"></el-input>
            </el-form-item> -->
            <el-form-item label="工厂名称:">
                <el-select v-model="dataForm.werks" clearable filterable placeholder="请选择工厂" @change="queryHandle">
                    <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryDesc" :value="item.factoryCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="物料编码:">
                <el-input size="small" v-model="dataForm.matnr" placeholder="物料编码" clearable @blur="queryHandle"></el-input>
            </el-form-item>
            <el-form-item label="计划日期区间:" label-width="100px">
                <el-date-picker unlink-panels v-model="dataForm.perxx" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable @blur="getDataList">
                </el-date-picker>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="queryHandle" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建项目
                </el-button>
                <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-upload2">
                    导入项目
                </el-button> -->
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :header-cell-style="{background:'#f5f5f5'}" border :data="dataList" row-key="id" size="mini" style="width: 100%;" :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="werks" header-align="center" align="center" label="工厂">
                </el-table-column> -->
                <el-table-column prop="name2" header-align="center" align="center" label="工厂名称">
                    <template slot-scope="scope">
                        <span>{{getFactoryName(scope.row.werks)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="matnr" header-align="center" align="center" label="物料编码">
                </el-table-column>
                <el-table-column prop="maktx" header-align="center" align="center" label="物料描述">
                </el-table-column>
                <el-table-column prop="zmenge11" header-align="center" align="right" label="M+1数量">
                </el-table-column>
                <el-table-column prop="zmenge22" header-align="center" align="right" label="M+2数量">
                </el-table-column>
                <el-table-column prop="zmenge33" header-align="center" align="right" label="M+3数量">
                </el-table-column>
                <el-table-column prop="perxx" header-align="center" align="center" :formatter="dateFormat" label="计划期间">
                </el-table-column>
                <el-table-column prop="zfbrq" header-align="center" align="center" label="发布日期" :formatter="dateFormat" width="100">
                </el-table-column>
                <!-- <el-table-column header-align="center" align="left" width="190" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>
                    </template>
                </el-table-column> -->
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    getCarForecastList,
    removeCarForecast,
    // list
} from '@/controller/sap'
import {
    getFactoryList,
} from '@/controller/systemData'
import AddOrUpdate from './car-forecast-add-or-update'
import moment from 'moment'
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                perxx: '',
                werks: '',
                name2: '',
                matnr: '',
                maktx: '',
                zmenge11: '',
                zmenge22: '',
                zmenge33: '',
                zfbrq: '',
            },
            dataList: [],
            tenantList: [],
            factoryList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 220
            }
        }
    },

    components: {
        AddOrUpdate
    },
    activated() {
        this.getDataList()
    },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        queryHandle(){
            this.pageIndex = 1
            this.getDataList()
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            this.getFactoryList()
            getCarForecastList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                'werks': this.dataForm.werks,
                'name2': this.dataForm.name2,
                'matnr': this.dataForm.matnr,
                'maktx': this.dataForm.maktx,
                'zmenge11': this.dataForm.zmenge11,
                'zmenge22': this.dataForm.zmenge22,
                'zmenge33': this.dataForm.zmenge33,
                'zfbrq': this.dataForm.zfbrq,
                'perxxStart': this.dataForm.perxx==null?this.dataForm.perxx:this.dataForm.perxx[0],//计划日区间开始
                'perxxEnd': this.dataForm.perxx==null?this.dataForm.perxx:this.dataForm.perxx[1]//计划日区间结束
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                    // console.log(this.dataList, "this.dataList")
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'view')
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'edit')
            })
        },
        // 删除
        deleteHandle(id) {
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                removeCarForecast({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        getFactoryList() {
            getFactoryList({
                post: "",
                address: "",
                factoryDesc: "",
                factoryCode: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.factoryDesc = ""
            })
        },
        getFactoryName(code) {
            const factory = this.factoryList.find(factory => factory.factoryCode === code)
            return factory ? factory.factoryDesc : ''
        },
        setFactoryName(val) {
            console.log(val)
            const factory = this.factoryList.find(factory => factory.factoryCode === val)
            this.dataForm.name2 = factory ? factory.factoryDesc : ''
        },
    }
}
</script>
